export const timeHelper = () => {
  const currentDate = new Date();
  const hours = currentDate.getHours().toString().padStart(2, '0');
  const minutes = currentDate.getMinutes().toString().padStart(2, '0');
  const seconds = currentDate.getSeconds().toString().padStart(2, '0');
  return `${hours}:${minutes}:${seconds}`;
};

export const dateHelper = (date) => {
  const currentDate = new Date(date);
  const day = currentDate.getDate().toString().padStart(2, '0');
  const month = (currentDate.getMonth() + 1).toString().padStart(2, '0'); // Month is zero-based, so add 1
  const year = currentDate.getFullYear().toString();
  return `${day}/${month}/${year}`;
};

export const timeHelperWithMinutesAndSecond = (second) => {
  const minutes = String(Math.floor(second / 60)).padStart(2, '0');
  const seconds = String(Math.ceil(second % 60)).padStart(2, '0');
  return `${minutes}:${seconds}`;
};
